/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import i18next, { I18NextVue } from '@/config/i18n'

export function registerPlugins (app) {
  app.use(vuetify)
  app.use(I18NextVue, { i18next })
}
